import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { AppService } from "src/_services/app.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  MAT_DIALOG_DATA,
  MatDatepickerInputEvent,
  MatDialog,
  MatDialogRef,
  MatPaginator,
  MatTableDataSource,
  PageEvent,
} from "@angular/material";
import * as moment from "moment";
import { CommonModalComponent } from "../common-dialog-management/common-dialog.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-catalogue-management",
  templateUrl: "./catalogue-management.component.html",
  styleUrls: ["./catalogue-management.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CatalogueManagementComponent implements OnInit {
  providers: any[] = [];
  sportsList: any[] = [];
  ProviderId: string = "";
  showAlert: boolean = false;
  competitionsAfterSearch;
  eventListAfterSearch;
  sportId: string = "";
  selectedTab;
  searchKey = "";
  eventsList: any = [];
  competitionList: any = [];
  toggleDatePickerValue: boolean = false;
  operatorData = new MatTableDataSource<any>();
  selected: any = {
    startDate: null,
    endDate: null,
  };
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };
  eventsTableHeaders: string[] = [
    "Event Date",
    "Event Name",
    "Event Id",
    "Competition Name",
    "Status",
    "Modified By",
    "Modified Date",
    "Action",
  ];

  competitionsHeaderList: string[] = [
    "Competition Name",
    "Competition Id",
    "Status",
    "Modified By",
    "Modified Date",
    "Action",
  ];
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  eventPageSize: number = 0;

  pageCompetition = 1;
  pageSizeCompetition = 25;
  orgPageSizeCompetition = 25;
  lengthCompetition: any = 0;

  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  pageEventCompetition: any = { pageIndex: 1, pageSize: 0, length: 0 };

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit() {
    this.getOurProviders();
    this.selected = {
      startDate: (function (d) {
        d.setDate(d.getDate() - 5);
        return moment(d.setHours(0, 0, 0, 0));
      })(new Date()),
      endDate: (function (d) {
        d.setDate(d.getDate() + 2);
        return moment(d.setHours(23, 59, 59, 999));
      })(new Date()),
    };
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  handleChange(value, element) {
    try {
      this.appService
        .changeCompetitionStatus(
          this.ProviderId,
          this.sportId,
          element.competitionId,
          value.checked === false ? "BLOCKED" : "ACTIVE"
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.getCompetitions();
            this.getEvents();
          }
        });
    } catch (err) {}
  }

  changeStatus = (data, type) => {
    try {
      this.appService
        .getOperatorsData({
          ProviderId: this.ProviderId,
          SportId: this.sportId,
          CompetitionId: type === "competition" ? data.competitionId : "",
          EventId: type === "competition" ? "" : data.event_id,
        })
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.operatorData.data = res.providers;
            this.dialog.open(CommonModalComponent, {
              backdropClass: "backdropBackground",
              hasBackdrop: true,
              data: {
                providersStatus: this.operatorData,
                title:
                  type === "event" ? data.event_name : data.competitionName,
                proStatus:
                  type === "event" ? data.status : data.competitionStatus,
                ProviderId: this.ProviderId,
                sportId: this.sportId,
                CompetitionId:
                  type === "event" ? data.competition_id : data.competitionId,
                EventId: type === "event" ? data.event_id : "",
                For: "SAP",
                code: 0,
                level: type === "event" ? "event" : "competition",
              },
            });
          }
        });
    } catch (err) {}
  };

  handleEventStatusChange(value, element) {
    try {
      this.appService
        .changeCatalogEventStatus(
          this.ProviderId,
          this.sportId,
          element.event_id,
          value.checked === false ? "BLOCKED" : "ACTIVE"
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.getEvents();
            this.getCompetitions();
          }
        });
    } catch (err) {}
  }

  openEditModal(data) {
    let payload = {
      eventId : data.event_id,
      sportId : data.sport_id,
    }
   let eventStatus = "";
   let status = "";
   let openDate = data.open_date;
    try {
      this.appService.getRXEventStatus(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          eventStatus = res.eventStatus
          status = res.eStatus
          if (res.openDate) {
            openDate = res.openDate
          }
        }
        this.dialog.open(CreateRXEvent, {
          backdropClass: "backdropBackground",
          hasBackdrop: true,
          data: {
            title: "Change Event Status",
            eventId: data.event_id,
            sportId: data.sport_id,
            eventStatus:eventStatus,
            openDate: openDate,
            status: status,
          },
        });
      });
    } catch (err) {}
  }

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.endDate) {
      let start = this.selected.startDate;
      let end = this.selected.endDate;
      let diff = end.diff(start, "days") + 1;
      if (diff > 7) {
        this.showAlert = true;
        this.selected.startDate = moment(
          new Date(new Date().setDate(new Date().getDate() - 5))
        );
        this.selected.endDate = moment(
          new Date(new Date().setDate(new Date().getDate() + 2))
        );
        setTimeout(() => {
          this.showAlert = false;
        }, 5000);
      } else if (this.selected.startDate !== null) {
        this.getCompetitions();
        this.getEvents();
      }
    }
  };

  toggleDatePicker() {
    this.toggleDatePickerValue = !this.toggleDatePickerValue;
  }

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
      this.ProviderId = this.providers[0].ProviderId;
    } catch (err) {}
  }

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportData(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sportsList = res.sports;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  changePaginationCompetition(event: PageEvent) {
    this.pageEventCompetition = event;
    this.pageCompetition = event.pageIndex + 1;
    this.pageSizeCompetition = event.pageSize;
    this.orgPageSizeCompetition = event.pageSize;
    this.getCompetitions();
  }

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.orgPageSize = event.pageSize;
    this.getEvents();
  }

  onSelectedProviderId(providerId) {
    this.ProviderId = providerId;
    this.eventsList = [];
    this.eventListAfterSearch = [];
    this.competitionsAfterSearch = [];
    this.sportId = "";
    this.eventsList = [];
    this.competitionList = [];
    this.getSportsByProvider(this.ProviderId);
  }

  onSelectedSportName(SportId) {
    this.sportId = SportId;
    this.eventsList = [];
    this.competitionList = [];

    this.getCompetitions();
    this.getEvents();
  }

  onSelectedListChange(event) {
    this.selectedTab = event;
    this.searchKey = "";
    this.competitionsAfterSearch = this.competitionList;
    this.eventListAfterSearch = this.eventsList;
    if (this.selectedTab == "Competitions") {
      this.paginator.length = this.lengthCompetition;
    } else if (this.selectedTab == "Events") {
      this.paginator.length = this.eventPageSize;
    }
  }

  searchChangeHandler(value) {
    if (this.searchKey.length >= 1) {
      this.eventListAfterSearch = this.eventsList.filter((event) => {
        if (
          event.event_name
            .toLowerCase()
            .includes(this.searchKey.toLowerCase()) ||
          event.event_id.includes(this.searchKey)
        ) {
          return event;
        }
      });

      this.competitionsAfterSearch = this.competitionList.filter(
        (competition) => {
          if (
            competition.competitionName
              .toLowerCase()
              .includes(this.searchKey.toLowerCase()) ||
            competition.competitionId
              .toLowerCase()
              .includes(this.searchKey.toLowerCase())
          ) {
            return competition;
          }
        }
      );
    } else {
      this.eventListAfterSearch = this.eventsList;
      this.competitionsAfterSearch = this.competitionList;
    }
  }

  getCompetitions() {
    try {
      this.appService
        .getCatalogCompetitions(
          this.ProviderId,
          this.sportId,
          this.selected.startDate,
          this.selected.endDate,
          this.pageCompetition,
          this.pageSizeCompetition
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.competitionsAfterSearch = res.competitions;
            this.competitionList = res.competitions;
            if (this.selectedTab == "Competitions") {
              this.paginator.length = res.totalRecords;
            }
            this.lengthCompetition = res.totalRecords;
          } else {
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
              this.router.navigateByUrl("/login");
            }
          }
        });
    } catch (err) {}
  }

  getBetPlaceDate(date: number) {
    return moment(date).format("DD MMM YYYY hh:mm A");
  }

  showExcelImage() {
    return this.ProviderId === 'BetFair' || this.ProviderId === 'SportRadar';
  }

  getEvents() {
    try {
      this.appService
        .getCatalogEvents(
          this.ProviderId,
          this.sportId,
          this.selected.startDate,
          this.selected.endDate,
          this.page,
          this.pageSize
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.eventListAfterSearch = res.Events;
            this.eventsList = res.Events;
            this.eventPageSize = res.totalRecords;
            if (this.selectedTab == "Events") {
              this.paginator.length = res.totalRecords;
            }
          } else {
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
              this.router.navigateByUrl("/login");
            }
          }
        });
    } catch (err) {}
  }

  b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  getExportExcel() {
    if (this.showExcelImage) {
      let filters: any = {
        providerId: this.ProviderId,
        sportId: this.sportId,
        startTime:
          this.selected.startDate !== null
            ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
            : 0,
        endTime:
          this.selected.endDate !== null
            ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
            : 0,
      };

      this.appService.getCatalogExportExcel(filters).subscribe((res) => {
        const contentType = "application/vnd.ms-excel";
        let blob1 = this.b64toBlob(res.file, contentType);
        let blobUrl1 = URL.createObjectURL(blob1);
        const link = document.createElement("a");
        link.href = blobUrl1;
        const epochTime = Math.floor(Date.now() / 1000);
        if (this.ProviderId === "SportRadar") {
          link.setAttribute("download", `SportsBook_${epochTime}.xlsx`);
      } else {
          link.setAttribute("download", `Exchange_${epochTime}.xlsx`);
      }
        document.body.appendChild(link);
        link.click();
      });
    }
  }
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./create-rx-event.html",
  styleUrls: ["./create-rx-event.scss"],
})
export class CreateRXEvent {
  openDate;
  selected = new FormControl();
  rxManual : FormGroup
  statuses = ["IN_PLAY","UPCOMING"]
  Eventstatuses = ["IN_PLAY","UPCOMING","CLOSED"]
  manualUpdate = false;
  eventUpdate = false;
  constructor(
    private appService: AppService,
    public dialogRef: MatDialogRef<CreateRXEvent>,
    @Inject(MAT_DIALOG_DATA) public Data: any
  ) {}

  data= this.Data

  ngOnInit() {
    if (this.data.openDate) {
      let date = moment(this.data.openDate);
      var stillUtc = moment.utc(date).toDate();
      this.openDate = this.data.openDate; // store epoch time in openDate
      this.selected.setValue({ startDate: moment(stillUtc), endDate: null }); // update FormControl
    } else {
      this.openDate = moment().startOf('minute').unix(); // store current epoch time without seconds in openDate
      this.selected.setValue({ startDate: moment().startOf('minute'), endDate: null }); // update FormControl
    }
    this.rxManual = new FormGroup({
      eventId: new FormControl (this.data.eventId, Validators.required),
      eventStatus: new FormControl (this.data.eventStatus),
      status: new FormControl (this.data.status),
    });
  }

  onDateChangeHandler(event: any): void {
    if (event.startDate) {
      this.openDate = moment(event.startDate).valueOf();
    } else {
      this.openDate = 0;
    }
    this.manualUpdate = true;
  }

  disable() {
    if (this.rxManual.value.status !== this.data.status) {
      this.eventUpdate = true; // Set event to true if there is a change in status

    } else {
      this.eventUpdate = false;
    }
     if (
      this.openDate !== this.data.openDate || 
      this.rxManual.value.eventStatus !== this.data.eventStatus
    ) {
      this.manualUpdate = true; // Set manual to true if there is a change in openDate or eventStatus
    } else {
      this.manualUpdate = false;
    }

    return (this.manualUpdate || this.eventUpdate)
  }
  confirm() {
    if (this.rxManual.value.status !== this.data.status) {
      this.eventUpdate = true; // Set event to true if there is a change in status

    } else {
      this.eventUpdate = false;
    }
     if (
      this.openDate !== this.data.openDate || 
      this.rxManual.value.eventStatus !== this.data.eventStatus
    ) {
      this.manualUpdate = true; // Set manual to true if there is a change in openDate or eventStatus
    } else {
      this.manualUpdate = false;
    }
    const payload = {
      eventId: this.rxManual.value.eventId,
      sportId: this.data.sportId,
      eventStatus: this.rxManual.value.eventStatus,
      status: this.rxManual.value.status,
      opendate: this.openDate,
      manual :this.manualUpdate,
      event: this.eventUpdate,
    }
    if (this.eventUpdate || this.manualUpdate) {
      try {
        this.appService.updateRXEventStatus(payload).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
            this.dialogRef.close(true);
          } else {
            this.appService.openErrorBar(res.errorDescription);
            this.dialogRef.close();
          }
        });
      } catch (err) {}
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}